import './big-board.css';

import base from '../base/base';
import header from '../base/header';

/**
 * TODO: fix issue on team bb pages
 *  import LazyloadVideo from '../../components/platformPlayer/LazyloadVideo';
 */
import AnchorNav from '../../components/anchor-nav/AnchorNav';
new AnchorNav();
